import * as React from "react";

export const IconDownload = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66667 9.33333C3.03486 9.33333 3.33333 9.63181 3.33333 10V12.6667C3.33333 12.8435 3.40357 13.0131 3.5286 13.1381C3.65362 13.2631 3.82319 13.3333 4 13.3333H12C12.1768 13.3333 12.3464 13.2631 12.4714 13.1381C12.5964 13.013 12.6667 12.8435 12.6667 12.6667V10C12.6667 9.63181 12.9651 9.33333 13.3333 9.33333C13.7015 9.33333 14 9.63181 14 10V12.6667C14 13.1971 13.7893 13.7058 13.4142 14.0809C13.0391 14.456 12.5304 14.6667 12 14.6667H4C3.46957 14.6667 2.96086 14.456 2.58579 14.0809C2.21071 13.7058 2 13.1971 2 12.6667V10C2 9.63181 2.29848 9.33333 2.66667 9.33333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.86193 6.19526C5.12228 5.93491 5.54439 5.93491 5.80474 6.19526L8 8.39052L10.1953 6.19526C10.4556 5.93491 10.8777 5.93491 11.1381 6.19526C11.3984 6.45561 11.3984 6.87772 11.1381 7.13807L8.4714 9.80474C8.21106 10.0651 7.78894 10.0651 7.5286 9.80474L4.86193 7.13807C4.60158 6.87772 4.60158 6.45561 4.86193 6.19526Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.33333C8.36819 1.33333 8.66667 1.63181 8.66667 2V9.33333C8.66667 9.70152 8.36819 10 8 10C7.63181 10 7.33333 9.70152 7.33333 9.33333V2C7.33333 1.63181 7.63181 1.33333 8 1.33333Z"
      fill="currentColor"
    />
  </svg>
);
